import { Link } from "react-router-dom";
import { Clock, Lock, MapPin, GraduationCap, Phone, Mail } from "lucide-react";
import { SITE } from "@/config";
import { SocialBubbles, CONTACT_PHONE, CONTACT_PHONE_HREF, CONTACT_EMAIL } from "@/components/SocialLinks";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-[hsl(var(--studio-ink))]" data-testid="app-footer">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <img
                src={SITE.headerLogo}
                alt={`Logo ${SITE.fullName}`}
                className="h-9 w-9 rounded-md border border-primary/40 object-cover"
              />
              <span className="font-heading text-lg font-semibold tracking-tight">
                {SITE.brandFirst} <span className="text-primary">{SITE.brandSecond}</span>
              </span>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">
              {SITE.footerDesc}
            </p>
            <SocialBubbles className="mt-4" />
          </div>
          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-muted-foreground">
              Informations
            </h3>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              {CONTACT_PHONE && (
                <li className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-primary" />
                  <a href={CONTACT_PHONE_HREF} className="font-medium text-foreground hover:text-primary" data-testid="footer-phone-link">
                    {CONTACT_PHONE}
                  </a>
                </li>
              )}
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary" />
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-primary" data-testid="footer-email-link">
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-primary" />
                Ouvert 24h/24 — 7j/7
              </li>
              <li className="flex items-center gap-2">
                <Lock className="h-4 w-4 text-primary" />
                CB · Apple Pay · Google Pay · Virement bancaire · Espèces (sur place)
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 flex-shrink-0 text-primary" />
                <span className="font-medium text-foreground">
                  47 avenue de la République, 69200 Vénissieux
                </span>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-muted-foreground">
              Navigation
            </h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/planning" className="text-muted-foreground hover:text-primary">
                  Voir le planning
                </Link>
              </li>
              <li>
                <Link to="/reserver" className="text-muted-foreground hover:text-primary">
                  Réserver un créneau
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary" data-testid="footer-contact-link">
                  Contactez-nous
                </Link>
              </li>
              <li>
                <Link to="/admin" className="text-muted-foreground hover:text-primary" data-testid="footer-admin-link">
                  Accès admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-border pt-6 text-xs text-muted-foreground">
          © {new Date().getFullYear()} {SITE.fullName}. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};
